module.exports = __webpack_public_path__ + "img/nothumb.ac0b467c.png";